import * as React from "react";
import {
  List, Datagrid, TextField, Show, SimpleShowLayout, SearchInput,
} from "react-admin";

// JobEnum est une énumération Java HARDCODÉE côté backend
// (com.healthcare.uman.model.user.JobEnum) : pas d'API POST/PUT/DELETE.
// Pour ajouter/supprimer un métier, il faut modifier l'enum + redéployer.
// → resource read-only. Les suggestions de métiers (proposées par les pros)
// sont gérées via /admin/suggestions/jobs (resource "suggestions-jobs").

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export default {
  list: () => (
    <List filters={filters} perPage={100} pagination={false} title="Métiers (lecture seule)">
      <Datagrid rowClick="show" bulkActionButtons={false}>
        {/* GET /pro/jobs renvoie des libellés (chaînes) : id = valeur = libellé. */}
        <TextField source="value" label="Métier" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="value" label="Métier" />
        </SimpleShowLayout>
    </Show>
  ),
};
